import getUrlParam from 'qj/getUrlParam';
import React from 'react';
import Icons, { IconNames } from './icons';
import List from './list';
import VesselListItem from './vesselListItem';
import ClosingTimes from './closingTimes';
import { Default, Mobile } from '../responsive';
import format from 'date-fns/format';

export default class VisitListOverview extends React.Component {
  constructor(props) {
    super(props);

    this.renderListItems = this.renderListItems.bind(this);
    this.onToggleChildren = this.onToggleChildren.bind(this);
    this.voyageParam = getUrlParam('voyage');

    this.state = { showChildren: null, singleItem: null };
  }

  mapItemsVoyages(VoyagesDTO) {
    if (!VoyagesDTO) {
      return [];
    }

    const headers = {
      Reference: 'Voyage',
      Name: 'Vessel',
      Description: 'Route',
      Updated: 'Updated'
    };

    const vessels = VoyagesDTO.map(item => {
      return {
        Reference: item.reference,
        Name: item.vessel.name,
        Description: item.description,
        Updated: format(item.lastChanged, 'DD.MM.YY hh:mm'),
        nextVoyage: item.nextVoyage,
        Icon: (
          <Icons
            iconName={IconNames.SortRight}
            iconClassName="arrowRight"
            className="arrowRightWrapper"
          />
        ),
        Visits: item.visits
      };
    });

    return { vessels, headers };
  }

  onToggleChildren(index) {
    this.setState({ singleItem: index });
  }

  renderSingleItem(vessels, headers) {
    if (
      this.state.singleItem !== null &&
      this.state.singleItem >= 0 &&
      this.state.singleItem <= vessels.length
    ) {
      const index = this.state.singleItem;
      const item = vessels[index];

      return (
        <ul className="list__items">
          <VesselListItem
            key={index}
            index={index}
            tag="div"
            items={item}
            className={'list__items__item overview'}
            headers={headers}
            showingGMT={this.props.showingGMT}
            showChildren={true}
            onToggleChildren={this.onToggleChildren}
            visits={item.Visits}
            showClosingTimes={this.props.showClosingTimes}
            nextVoyage={item.nextVoyage}
            lang={this.props.lang}
          />
        </ul>
      );
    } else {
      return this.renderAllItems(vessels, headers);
    }
  }

  renderAllItems(vessels, headers) {
    const self = this;
    const items = vessels.map((item, index) => {
      return (
        <VesselListItem
          key={index}
          index={index}
          tag="div"
          items={item}
          className={'list__items__item overview'}
          headers={headers}
          showingGMT={self.props.showingGMT}
          showChildren={item.Reference === this.voyageParam}
          onToggleChildren={self.onToggleChildren}
          visits={item.Visits}
          showClosingTimes={this.props.showClosingTimes}
          nextVoyage={item.nextVoyage}
          lang={this.props.lang}
        />
      );
    });

    return <ul className="list__items">{items}</ul>;
  }

  renderListItems() {
    const { vessels, headers } = this.mapItemsVoyages(this.props.voyages);
    return (
      <React.Fragment>
        <Default>{this.renderAllItems(vessels, headers)}</Default>
        <Mobile>{this.renderSingleItem(vessels, headers)}</Mobile>
      </React.Fragment>
    );
  }

  render() {
    const { headers } = this.mapItemsVoyages(this.props.voyages);

    return (
      <React.Fragment>
        <List
          headers={headers}
          portRegistry={this.props.portRegistry}
          showingGMT={this.props.showingGMT}
          renderListItems={this.renderListItems}
          hideHeaders
        />
        {this.props.showClosingTimes && this.state.singleItem === null && (
          <ClosingTimes
            className="closingTimes__standalone"
            title="Closing time for cargo"
            displayLinkOnly
          />
        )}
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/visitListOverview.js